/* mp-ai-motion.js — Testversion „Anton & Irene", 10.09.2026
 * Bewegung, die dem Scrollen folgt. Kein Framework:
 *  1. Reveal: Elemente mit data-ai-reveal fahren ein, wenn sie sichtbar werden.
 *     Bestehende Theme-Bloecke bekommen das Attribut automatisch (gestaffelt).
 *  2. Hero-Zeile: Woerter einzeln, jedes fuehrende E wird zum roten e (Signatur).
 *  3. Parallax: das Bild in Kapitel 02 bewegt sich langsamer als die Seite.
 *  4. Laufband: reine CSS-Animation, hier nur die Verdopplung des Inhalts.
 * prefers-reduced-motion wird ueberall respektiert.
 */
(function () {
  /* 17.09.2026: Texte uebersetzbar machen. window.mpT wird von snippets/head_assets.liquid
     aus den Sprachdateien (locales/*.json) gefuellt. Faellt mpT aus, bleibt der bisherige
     deutsche Text stehen - das Verhalten auf Deutsch aendert sich dadurch nicht. */
  function T(k, vorgabe) { var o = window.mpT; return (o && typeof o[k] === 'string' && o[k]) ? o[k] : vorgabe; }
  /* 18.09.2026: Interne Ziele muessen der Seitensprache folgen. routes.root_url ist "/" in der
     Vorgabesprache und "/en" bzw. "/tr" in einer Uebersetzung. Ohne das landete jeder hier
     gebaute Link auf der deutschen Fassung und warf den Besucher aus seiner Sprache. */
  function U(pfad) {
    var w = (window.mpT && window.mpT.wurzel) || '/';
    if (w === '/' || !/^\//.test(pfad) || pfad.indexOf(w + '/') === 0) return pfad;
    return w.replace(/\/$/, '') + pfad;
  }

  /* Einstellungen aus dem Theme-Editor (config/settings_schema.json, Gruppe "Peeck: A&I-Testversion"), von snippets/head_assets.liquid als JSON ausgegeben */
  var E = {}; try { E = JSON.parse((document.getElementById('ai-einstellungen') || {}).textContent || '{}'); } catch (err) {}
  function einst(k, ersatz) { var v = E[k]; return (v && String(v).trim()) ? String(v).trim() : ersatz; }
  var reduziert = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 2) Hero-Zeile: kein Wort-fuer-Wort mehr (wirkte wie ein Slider); nur das erste E wird rot */
  function heroWoerter() {
    return; // Runde 10: kein rotes e mehr im Hero
    var h = document.querySelector('[class*="background_video"] h1.t4s-text-bl');
    if (!h || h.dataset.aiWoerter) return;
    h.dataset.aiWoerter = '1';
    var ziel = h.querySelector('b, strong') || h;
    var w0 = document.createTreeWalker(ziel, NodeFilter.SHOW_TEXT), n, t = null;
    while ((n = w0.nextNode())) { if (n.textContent.trim()) { t = n; break; } }
    if (t && /^\s*E/.test(t.textContent)) {
      /* kleines rotes e wie im Logo: die Zeile beginnt bewusst mit dem Kleinbuchstaben */
      var e = document.createElement('span'); e.className = 'ai-e ai-e--klein'; e.textContent = 'e';
      var rest = document.createTextNode(t.textContent.replace(/^\s*E/, ''));
      t.parentNode.insertBefore(e, t); t.parentNode.replaceChild(rest, t);
    }
    h.classList.add('is-in');
  }

  /* 2b) Hero-Knoepfe und Terminknoepfe: feste Lucide-Icons als Inline-SVG (statt ::before-Masken,
     die vom Theme-Hover-Overlay verdeckt wurden) */
  var ICONS = {
    sofa: '<path d="M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3"/><path d="M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0z"/><path d="M4 18v2"/><path d="M20 18v2"/><path d="M12 4v9"/>',
    pot: '<path d="M2 12h20"/><path d="M20 14v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3"/><path d="m4 8 16-4"/><path d="m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8"/>',
    pin: '<path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/>',
    arrow: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>'
  };
  function icon(name) { return '<svg class="ai-ico" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + ICONS[name] + '</svg>'; }
  function heroKnoepfe() {
    document.querySelectorAll('[class*="background_video"] a[class*="btn"], .t4s-bg-video a[class*="btn"], .ai-buehne .ai-hero-btn').forEach(function (a) {
      if (a.dataset.aiIcoDone) return;
      var txt = a.textContent.toLowerCase();
      var name = a.dataset.aiIco || (/k[uü]che/.test(txt) ? 'pot' : /standort|mannheim|worms|weg/.test(txt) ? 'pin' : /m[oö]bel|wohnen|sofa/.test(txt) ? 'sofa' : 'arrow');
      if (name && ICONS[name]) a.insertAdjacentHTML('afterbegin', icon(name));
      a.dataset.aiIcoDone = '1'; a.classList.add('ai-hero-btn'); if (/[?&]appointment/.test(a.getAttribute('href') || '')) { a.classList.add('appointmentButton'); a.querySelectorAll('svg').forEach(function (sv) { sv.remove(); }); }
    });
  }

  /* 2c) Kopfzeile: Telefonnummer neben dem Terminknopf (GA4: Telefonklick ist die haeufigste Aktion) */
  function kopfTelefon() {
    var cta = document.querySelector('#menu-cta'); if (!cta || document.querySelector('.ai-header-tel')) return;
    cta.insertAdjacentHTML('beforebegin', '<a class="ai-header-tel" href="tel:' + einst('tel_link', '+49621727080') + '">' + icon('arrow').replace('ai-ico', 'ai-ico ai-ico--tel').replace(ICONS.arrow, '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>') + '<span>0621 72708-0</span></a>');
  }

  /* 2c1) Stabile Sprungziele: Shopify haengt die Vorlagenkennung vor jeden Sektionsnamen.
     Hier bekommt jede Sektion zusaetzlich ein Ziel mit ihrem reinen Namen, damit
     Verweise wie #mp_products_spuelen auf derselben Seite funktionieren. */
  function ankerIds() {
    document.querySelectorAll('main .shopify-section[id*="__"]').forEach(function (sek) {
      var m = sek.id.match(/__([A-Za-z0-9_-]+)$/);
      if (!m) return;
      var name = m[1];
      if (document.getElementById(name)) return;
      var a = document.createElement('span');
      a.id = name; a.className = 'ai-anker'; a.setAttribute('aria-hidden', 'true');
      sek.insertAdjacentElement('beforebegin', a);
    });
  }

  /* 2c2) Sprachwechsel: liegt als verstecktes Formular im Layout und wandert hier an zwei
     Stellen, in die Kopfleiste neben die Rufnummer und oben ins Mobilmenue. */
  function sprachwahl() {
    var q = document.getElementById('ai-sprachwahl');
    if (!q) return;
    q.hidden = false;
    var cta = document.querySelector('#menu-cta');
    if (cta && !document.querySelector('.t4s-header__wrapper .ai-sprachwahl')) {
      var tel = document.querySelector('.ai-header-tel');
      (tel || cta).insertAdjacentElement(tel ? 'beforebegin' : 'beforebegin', q);
    }
    /* Im Mobilmenue eine eigene Kopie, damit sie in beiden Ansichten erreichbar ist */
    var mb = document.querySelector('#menu-mb__ul');
    if (mb && !document.querySelector('.ai-sprachwahl--mb')) {
      var k = q.cloneNode(true);
      k.id = ''; k.classList.add('ai-sprachwahl--mb'); k.hidden = false;
      mb.insertAdjacentElement('afterbegin', k);
    }
  }

  /* 18.09.2026: Sicherheitsnetz fuer die Sprachfassungen. Sehr viele Ziele stehen in Inhalten,
     Sektions- und Theme-Einstellungen als absoluter deutscher Pfad ("/pages/faq"). Der Linktext
     wird uebersetzt, das Ziel nicht — in einer Uebersetzung fuehrt jeder davon zurueck ins
     Deutsche und beendet damit die Sprachsitzung des Besuchers. Gemessen am 18.09.2026: 50 solche
     Links auf sieben Seiten. Hier bekommt jeder interne Inhaltslink die Sprachwurzel vorangestellt.
     Eng gefasst: nur pages/collections/products/blogs, nicht /cart, /checkout, /account oder
     Dateien. In der Vorgabesprache ist wurzel "/" und die Funktion tut nichts. */
  function spracheLinks() {
    var w = (window.mpT && window.mpT.wurzel) || '/';
    if (w === '/') return;
    var praefix = w.replace(/\/$/, '');
    /* ⚠ 18.09.2026: KEIN "schon erledigt"-Merker hier. Das Theme baut die Menues nach dem Laden
       neu auf und setzt die Ziele dabei auf den deutschen Pfad zurueck; ein Merker haette den
       zweiten Durchlauf gesperrt und genau diese Links deutsch gelassen. Der Selektor trifft
       ohnehin nur unpraefixierte Pfade, die Funktion ist dadurch von selbst wiederholbar und
       heilt jeden Rueckfall beim naechsten Durchlauf. */
    document.querySelectorAll('a[href^="/pages/"], a[href^="/collections/"], a[href^="/products/"], a[href^="/blogs/"]').forEach(function (a) {
      a.setAttribute('href', praefix + a.getAttribute('href'));
      a.dataset.aiSprache = '1';
    });
  }

  /* ⚠ 18.09.2026: spracheLinks() allein reicht nicht. Das Theme baut Kopfleiste und Mobilmenue
     nach dem Laden neu auf und setzt einzelne Ziele dabei auf den deutschen Pfad zurueck —
     gemessen an den Aufklapp-Eintraegen von "Angebote". Ein Wettlauf ueber weitere Nachlaeufe
     waere nie sicher. Darum zusaetzlich der Klick selbst: wer in einer Uebersetzung auf ein
     internes Ziel ohne Sprachpraefix klickt, wird auf die Fassung seiner Sprache geschickt.
     Bewusst ausgenommen: Mittel- und Modifiertasten (neuer Tab), target=_blank und alles,
     was ein anderer Zuhoerer schon behandelt hat. In der Vorgabesprache passiert nichts. */
  function spracheKlick() {
    if (window.__aiSpracheKlick) return;
    window.__aiSpracheKlick = 1;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.target === '_blank') return;
      var h = a.getAttribute('href');
      if (!h || !/^\/(pages|collections|products|blogs)\//.test(h)) return;
      var w = (window.mpT && window.mpT.wurzel) || '/';
      if (w === '/') return;
      e.preventDefault();
      location.href = w.replace(/\/$/, '') + h;
    }, true);
  }

  /* 2d) Beratungskarte im Produktraster hinter der zweiten Zeile (auch nach AJAX-Filtern) */
  function beratungskarte() {
    if (!/template-collection|template-search/.test(document.body.className)) return;
    if (!beratungskarte.an) { beratungskarte.an = 1; var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(beratungskarte, 250); }); }
    var grid = document.querySelector('main .shopify-section[id*="__main"] [data-ntajax-container] .t4s-products, main .shopify-section[id*="__main"] .t4s-products'); if (!grid) return;
    var items = grid.querySelectorAll(':scope > .t4s-product');
    var karte = grid.querySelector(':scope > .ai-beratungskarte');
    /* ⚠⚠ 16.09.2026: Die Karte lag bisher hinter der sechsten Kachel und war so breit wie
       eine Kachel. Zwoelf Produkte plus Karte sind dreizehn Elemente — die letzte Zeile
       zeigte darum ein einzelnes Moebel, mittig, und darunter „Mehr anzeigen". Die Karte
       laeuft jetzt ueber die volle Breite und steht am ENDE einer Zeile, damit die
       Produktzeilen vollstaendig bleiben. */
    var spalten = 4;
    try {
      var gb = grid.getBoundingClientRect().width, kb = items[0].getBoundingClientRect().width;
      if (kb > 0) spalten = Math.max(1, Math.round(gb / kb));
    } catch (e) {}
    /* ⚠ 26.10.2026 (Felix): Bei neun Produkten in vier Spalten stand nach der Karte ein
       einzelnes Moebel allein. Die Karte kommt nur, wenn danach noch mindestens eine volle
       Zeile folgt, sonst wird sie entfernt (Filter, Sortierung, Fenstergroesse). */
    if (items.length < spalten * 3) { if (karte) karte.remove(); return; }
    var ref = items[spalten * 2 - 1];   // hinter der zweiten vollen Zeile
    // Das Theme baut das Raster nach dem Laden neu (Filter, Sortierung): die Karte rutscht dann an Position 1. Hier zurueck hinter die sechste Kachel.
    if (karte) { if (karte.previousElementSibling !== ref) ref.insertAdjacentElement('afterend', karte); return; }
    var cls = '';   // volle Breite, nicht die Spaltenklassen der Kacheln
    var vorwahl = (document.getElementById('appointmentData') || {}).textContent || '';
    var kueche = /53/.test(vorwahl) || /k[uü]che|koch|back|kuehl|kühl|sp[uü]l|dunst|ger[aä]t/.test(location.pathname.toLowerCase());
    var ort = kueche ? T('ort_kuechenstudio', 'Küchenstudio') : T('ort_ausstellung', 'Ausstellung');
    var ortSatz = kueche ? T('ortsatz_kuechenstudio', 'im Küchenstudio') : T('ortsatz_ausstellung', 'in der Ausstellung');
    var bild = kueche ? einst('beratung_bild_kueche', 'https://cdn.shopify.com/s/files/1/0494/6870/2877/files/2025-04_Peeck_Ausstellung_GFXE3210_web.jpg') : einst('beratung_bild_moebel', 'https://cdn.shopify.com/s/files/1/0494/6870/2877/files/2025-04-09_Peeck_Ausstellung_GFXE3259.jpg');
    bild = bild.replace(/[?&]width=\d+/, '');
    var pfeil = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    karte = document.createElement('div');
    karte.className = 't4s-col-item ai-beratungskarte ' + cls;
    karte.innerHTML = '<div class="ai-beratungskarte__in"><a class="ai-beratungskarte__bild" href="' + location.pathname + '?appointment" aria-label="' + T('termin', 'Termin') + ' ' + ortSatz + '"><img src="' + bild + '?width=700" srcset="' + bild + '?width=500 500w, ' + bild + '?width=700 700w, ' + bild + '?width=1000 1000w" sizes="(min-width: 992px) 25vw, 50vw" alt="' + T('bild_alt_vor', 'Unsere ') + ort.toLowerCase() + T('bild_alt_nach', ' in Mannheim') + '" loading="lazy" width="700" height="467"></a><div class="ai-beratungskarte__text"><div class="ai-beratungskarte__kopf"><p class="ai-beratungskarte__kicker">' + T('beratung_kicker', 'Beratung') + '</p><h3 class="ai-beratungskarte__titel">' + einst('beratung_titel', 'Lieber erst mal reden?') + '</h3><p class="ai-beratungskarte__satz">' + einst('beratung_satz', 'Modelle zeigen, Maße prüfen, in Ruhe planen.') + '</p></div><div class="ai-beratungskarte__aktion"><a class="ai-beratungskarte__link appointmentButton" href="' + location.pathname + '?appointment">' + T('termin', 'Termin') + ' ' + ortSatz + pfeil + '</a>' + (kueche ? '<a class="ai-beratungskarte__link ai-beratungskarte__ki funnelButton" data-mp-funnel="kuechenwunsch" data-mp-bereich="kueche" href="/pages/traumkueche-planen">' + T('ki_start', 'KI-Küchenplaner starten') + '</a>' : '') + '<a class="ai-beratungskarte__tel" href="tel:' + einst('tel_link', '+49621727080') + '">' + einst('tel_anzeige', '0621 72708-0') + '</a></div></div></div>';
    ref.insertAdjacentElement('afterend', karte);
    karte.classList.add('is-in');
  }
  /* 2d) Mobilmenue: Satzschrift, "Aktionen" heisst Angebote, roter Terminknopf oben (nur Testversion, greift nicht in die Shopify-Navigation ein) */

  /* Runde 11 (Persona-Tests): Mobilmenue, ganze Zeile klappt das Untermenue auf; erste Zeile = Uebersicht; Kontaktblock mit Fragen/Preisgarantie/Service/Jobs und Teams. */

  /* Runde 11: Suchseite, Antworten (Seiten und Ratgeber) ueber den Produkttreffern, per Predictive-Search-API unabhaengig vom Produkt-Ranking. */
  function suchAntworten() {
    if (!/template-search/.test(document.body.className)) return;
    var q = new URLSearchParams(location.search).get('q'); if (!q) return;
    var hinweis = document.querySelector('.ai-such-hinweis'); if (!hinweis || hinweis.dataset.aiAntw) return; hinweis.dataset.aiAntw = '1';
    /* Gepflegte Zuordnung typischer Fragen zu unseren Antwortseiten (die Shop-Suche findet Seiten nur ueber den Titel). */
    var karte = [
      [/kostet|kosten|preis|budget|günstig|teuer|was kostet/i, { title: T('sa1_titel', 'Was kostet eine Küche?'), url: U('/pages/faq'), body: T('sa1_text', 'Bei uns startet eine einfache Einbauküche meist bei 5.000 Euro. Was den Preis bestimmt und wie die Beratung abläuft: Fragen und Antworten.') }],
      [/garantie|bestpreis/i, { title: T('sa2_titel', 'Preisgarantie'), url: U('/pages/preisgarantie'), body: T('sa2_text', 'Gleicher Artikel anderswo günstiger? Unsere Bestpreisgarantie.') }],
      [/objekt|gewerbe|vermieter|wohnungen|praxis|b2b|büro/i, { title: T('sa3_titel', 'Mehrere Küchen oder Wohnungen?'), url: U('/pages/service'), body: T('sa3_text', 'Ansprechpartner für Objektkunden, Vermieter und Gewerbe.') }],
      [/probeliegen|boxspring|matratze|bett|schlaf/i, { title: T('sa4_titel', 'Betten zum Probeliegen'), url: U('/collections/schlafen'), body: T('sa4_text', 'Boxspring, Polsterbett und Matratzen, Probeliegen in Mannheim und Worms.') }],
      [/termin|beratung|planung/i, { title: T('sa5_titel', 'Planungstermin vereinbaren'), url: U('/pages/kuechen') + '?appointment', body: T('sa5_text', 'Termin im Küchenstudio oder Möbelhaus, in Mannheim oder Worms.') }],
      [/öffnungszeit|adresse|anfahrt|standort|mannheim|worms|parken/i, { title: T('sa6_titel', 'Unsere Häuser und Öffnungszeiten'), url: U('/pages/standorte'), body: T('sa6_text', 'Mannheim, Worms und Cottbus: Adressen, Zeiten, Teams.') }],
      [/job|stelle|bewerb|ausbildung|karriere/i, { title: T('sa7_titel', 'Offene Stellen'), url: U('/pages/jobs'), body: T('sa7_text', 'Verkauf, Küchenplanung, Montage und Lager.') }],
      [/lieferung|montage|reklamation|ersatzteil|nachbestell|reparatur|service|kundendienst/i, { title: T('sa8_titel', 'Service nach dem Kauf'), url: U('/pages/service'), body: T('sa8_text', 'Lieferung, Montage, Nachbestellung, Ersatzteile und Reklamation.') }],
      [/ausstellungsst|abverkauf|reduziert|sofort|angebot|aktion|prospekt/i, { title: T('sa9_titel', 'Angebote und Ausstellungsstücke'), url: U('/pages/angebote'), body: T('sa9_text', 'Abholpreise aus Mannheim und Worms, Ausstellungsstücke sofort verfügbar.') }]
    ];
    var kur = []; karte.forEach(function (k) { if (kur.length < 2 && k[0].test(q)) kur.push(k[1]); });
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=page,article&resources[limit]=3').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (d) {
      var res = (d && d.resources && d.resources.results) || {}; var api = [].concat(res.pages || [], res.articles || []).filter(function (it) { return !kur.some(function (k) { return k.url === it.url; }); });
      var items = kur.concat(api).slice(0, 4);
      if (!items.length) return;
      var alt = document.querySelector('.ai-such-antworten'); if (alt) alt.remove();
      var box = document.createElement('div'); box.className = 'ai-such-antworten';
      box.innerHTML = '<p class="ai-such-antworten__kopf">' + T('antworten', 'Antworten') + '</p><ul>' + items.map(function (it) { var txt = (it.summary_html || it.body || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().split(' ').slice(0, 22).join(' '); return '<li><a href="' + it.url + '">' + it.title + '</a>' + (txt ? '<span>' + txt + '</span>' : '') + '</li>'; }).join('') + '</ul>';
      hinweis.parentNode.insertBefore(box, hinweis);
    }).catch(function () {});
  }

  /* Runde 14: Schliessen-X ins Menue, Karte laden bei Marketing-Consent, Sortier-Label, Chip-Icons */
  /* 16.09.2026: Das X steht im Kopf der Schublade (templates/search.mn.liquid). Diese Funktion
     ist nur noch der Rueckfall, falls die Vorlage einmal nicht mitgezogen wird; [data-drawer-close]
     ist der Haken des Themes (global.min.js), Escape schliesst ebenfalls. */
  function drawerX() {
    var d = document.querySelector('#t4s-menu-drawer'); if (!d || d.querySelector('[data-drawer-close]')) return;
    var kopf = d.querySelector('.mp-mbmenu__head') || d.querySelector('.t4s-drawer__header'); if (!kopf) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mp-mbmenu__zu'; b.setAttribute('data-drawer-close', ''); b.setAttribute('aria-label', T('menue_schliessen', 'Menü schließen'));
    b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12"></path><path d="M18 6L6 18"></path></svg>';
    kopf.appendChild(b);
  }
  /* 16.09.2026: Der rote Punkt im Untermenue markiert die Seite, auf der man steht.
     Vorher haftete er per :last-child an der letzten Zeile, dadurch sah in jedem Menue
     der letzte Unterpunkt vorausgewaehlt aus. */
  function menueAktuell() {
    var d = document.querySelector('#t4s-menu-drawer'); if (!d) return;
    var hier = location.pathname.replace(/\/$/, '') || '/';
    d.querySelectorAll('#menu-mb__ul a[href]').forEach(function (a) {
      var z = (a.getAttribute('href') || '').split('?')[0].split('#')[0].replace(/\/$/, '') || '/';
      if (z === hier && hier !== '/') a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
    });
  }
  function consentMarketing() {
    try { var c = window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.currentVisitorConsent && Shopify.customerPrivacy.currentVisitorConsent(); if (c && c.marketing === 'yes') return true; } catch (e) {}
    try { var m = document.cookie.match(/_tracking_consent=([^;]+)/); if (m) { var j = JSON.parse(decodeURIComponent(m[1])); if (j && j.purposes && j.purposes.m === true) return true; } } catch (e) {}
    return false;
  }
  function kartenFreigabe() {
    var laden = function () { document.querySelectorAll('.mp-gmaps').forEach(function (w) { if (w.dataset.aiKarte) return; var b = w.querySelector('button'); if (b) { w.dataset.aiKarte = '1'; b.click(); } }); };
    if (consentMarketing()) laden();
    if (!window.__aiKartenHook) { window.__aiKartenHook = 1; document.addEventListener('visitorConsentCollected', function (e) { var d = e && e.detail; if ((d && (d.marketingAllowed === true || d.marketing === 'yes')) || consentMarketing()) laden(); }); }
  }
  function sortWort() {
    document.querySelectorAll('.t4s-dropdown__sortby span, .t4s-dropdown__sortby a, .t4s-dropdown__sortby button, [data-sort-by] option').forEach(function (e) {
      e.childNodes.forEach(function (n) { if (n.nodeType === 3 && /Ausgewählt/.test(n.textContent)) n.textContent = n.textContent.replace(T('ausgewaehlt', 'Ausgewählt'), T('empfohlen', 'Empfohlen')); });
    });
  }
  function chipIcons() {
    var ic = {
      bett: '<path d="M2 4v16"/><path d="M2 8h18a2 2 0 0 1 2 2v10"/><path d="M2 17h20"/><path d="M6 8v9"/>',
      schrank: '<rect x="4" y="2" width="16" height="20" rx="2"/><path d="M12 2v20"/><path d="M9 12h.01"/><path d="M15 12h.01"/>',
      tisch: '<path d="M3 8h18"/><path d="M5 8v12"/><path d="M19 8v12"/><path d="M3 14h18"/>',
      stuhl: '<path d="M6 19v-6"/><path d="M18 19v-6"/><path d="M6 13h12"/><path d="M8 13V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v8"/>',
      sofa: '<path d="M4 18v2"/><path d="M20 18v2"/><path d="M2 12h20v6H2z"/><path d="M4 12V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4"/>',
      kueche: '<path d="M3 10h18"/><path d="M5 10v10"/><path d="M19 10v10"/><path d="M8 5h8"/><path d="M12 3v2"/><path d="M3 20h18"/>',
      insel: '<rect x="3" y="9" width="18" height="8" rx="1"/><path d="M6 17v3"/><path d="M18 17v3"/><path d="M9 6h6"/>',
      matratze: '<rect x="2" y="7" width="20" height="10" rx="2"/><path d="M6 12h.01"/><path d="M12 12h.01"/><path d="M18 12h.01"/>',
      lform: '<path d="M4 4v16h16"/><path d="M4 12h8"/>',
      uform: '<path d="M4 4v16h16V4"/>',
      zeile: '<path d="M3 12h18"/><path d="M3 6h18"/><path d="M3 18h18"/>',
      alle: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
      kochfeld: '<circle cx="8" cy="8" r="3"/><circle cx="16" cy="8" r="3"/><circle cx="8" cy="16" r="3"/><circle cx="16" cy="16" r="3"/>',
      geraet: '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M4 9h16"/><circle cx="12" cy="15" r="3"/>',
      kuehl: '<rect x="5" y="2" width="14" height="20" rx="2"/><path d="M5 10h14"/><path d="M9 6v2"/><path d="M9 14v3"/>',
      spuele: '<path d="M3 11h18v4a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z"/><path d="M12 11V5"/><path d="M12 5h3"/>',
      licht: '<path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z"/>',
      muell: '<path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M6 6l1 14h10l1-14"/>',
      zubehoer: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3"/><path d="M12 19v3"/><path d="M2 12h3"/><path d="M19 12h3"/>'
    };
    var map = [[/^alle/i, 'alle'], [/boxspring|polsterbett|betten/i, 'bett'], [/matratze/i, 'matratze'], [/schrank|schränke/i, 'schrank'], [/tisch/i, 'tisch'], [/stuhl|stühle/i, 'stuhl'], [/sofa|couch|sessel/i, 'sofa'], [/insel/i, 'insel'], [/l-form/i, 'lform'], [/u-form/i, 'uform'], [/zeile/i, 'zeile'], [/kochfeld|mulden/i, 'kochfeld'], [/backofen|backöfen|dampfgarer|mikrowelle/i, 'geraet'], [/kühl|wein/i, 'kuehl'], [/spüle|armatur|geschirr/i, 'spuele'], [/beleucht|licht/i, 'licht'], [/müll/i, 'muell'], [/zubehör/i, 'zubehoer'], [/küche/i, 'kueche']];
    document.querySelectorAll('.mp-toolbar-chip').forEach(function (c) {
      if (c.dataset.aiIco) return; c.dataset.aiIco = '1';
      var txt = c.textContent.trim(), key = null; map.some(function (m) { if (m[0].test(txt)) { key = m[1]; return true; } });
      if (!key) return;
      c.insertAdjacentHTML('afterbegin', '<svg class="mp-toolbar-chip__ico" viewBox="0 0 24 24" aria-hidden="true">' + ic[key] + '</svg>');
    });
  }

  /* Runde 15 (UX-Testbericht): zugaengliche Namen, zweiter H1, Sortierwert, Suchtreffer nach Typ */
  function zugaenglich() {
    var setz = function (sel, label) {
      document.querySelectorAll(sel).forEach(function (e) {
        if (!e || e.dataset.aiAria) return;
        var hat = (e.getAttribute('aria-label') || '').trim() || (e.getAttribute('title') || '').trim() || (e.textContent || '').trim();
        if (!hat) { e.setAttribute('aria-label', label); e.dataset.aiAria = '1'; }
      });
    };
    setz('a.t4s-push-menu-btn, [data-drawer-options*="menu-drawer"]', T('menue_oeffnen', 'Hauptmenü öffnen'));
    setz('[data-drawer-options*="search-hidden"], a[href="#t4s-search-hidden"], .mp-mbmenu__suche', T('suche_oeffnen', 'Suche öffnen'));
    setz('.t4s-close-overlay, [data-drawer-close]', T('schliessen', 'Schließen'));
    document.querySelectorAll('.t4s-dropdown__sortby > button, [data-dropdown-open][data-id*="sortby"]').forEach(function (e) { if (!e.getAttribute('aria-label')) e.setAttribute('aria-label', T('sortierung', 'Sortierung auswählen')); });
    setz('.mp-toolbar-trigger', T('ausstellung_filtern', 'Ausstellungsstücke filtern'));
    document.querySelectorAll('form[action*="/search"] input[name="q"], input[name="q"]').forEach(function (i) {
      if (!i.dataset.aiAria) { if (!i.getAttribute('aria-label')) i.setAttribute('aria-label', T('suchfeld', 'Website durchsuchen')); if (!i.placeholder) i.placeholder = T('such_platzhalter', 'z. B. Schlafsofa, Rolf Benz oder Esstisch'); i.dataset.aiAria = '1'; }
    });
    document.querySelectorAll('form[action*="/search"] button[type="submit"], form[action*="/search"] button:not([type])').forEach(function (b) {
      if (!b.dataset.aiAria && !(b.textContent || '').trim()) { b.setAttribute('aria-label', T('suche_starten', 'Suche starten')); b.dataset.aiAria = '1'; }
    });
    /* Nur ein H1 je Seite: einen versteckten SEO-H1 zur Ueberschrift zweiter Ordnung machen */
    var h1 = document.querySelectorAll('h1');
    if (h1.length > 1) {
      var sichtbar = [].filter.call(h1, function (h) { return !/visually-hidden|sr-only/.test(h.className || ''); });
      if (sichtbar.length) {
        [].forEach.call(h1, function (h) {
          if (/visually-hidden|sr-only/.test(h.className || '') && !h.dataset.aiH2) {
            var n = document.createElement('h2'); n.className = h.className; n.innerHTML = h.innerHTML; n.dataset.aiH2 = '1'; h.parentNode.replaceChild(n, h);
          }
        });
      }
    }
  }
  /* Sortierfeld: Shopify blendet den Wert auf Mobil aus, wir spiegeln ihn in die mobile Zeile */
  function sortWert() {
    document.querySelectorAll('.t4s-dropdown__sortby > button').forEach(function (b) {
      var voll = b.querySelector('.t4s-d-none.t4s-d-md-block'), mob = b.querySelector('[data-not-change-txt]');
      if (voll && mob && !mob.textContent.trim()) mob.textContent = voll.textContent.trim();
    });
  }
  /* Suchseite: Treffer nach Inhaltstyp getrennt anbieten (Shopify sucht im Volltext, deshalb die grosse Gesamtzahl) */
  function suchTypen() {
    if (!/template-search/.test(document.body.className)) return;
    var p = new URLSearchParams(location.search), q = p.get('q'); if (!q) return;
    var ziel = document.querySelector('.ai-such-hinweis'); if (!ziel || ziel.dataset.aiTypen) return; ziel.dataset.aiTypen = '1';
    var typ = p.get('type') || '', ist = function (t) { return typ === t || (typ.indexOf(',') > -1 && t === ''); };
    var basis = '/search?q=' + encodeURIComponent(q);
    var zeile = document.createElement('nav'); zeile.className = 'ai-such-typen'; zeile.setAttribute('aria-label', 'Treffer nach Art filtern');
    var opt = [['', 'Alles'], ['product', 'Produkte'], ['article', 'Ratgeber'], ['page', 'Seiten']];
    zeile.innerHTML = opt.map(function (o) {
      var href = o[0] ? basis + '&type=' + o[0] : basis + '&type=product%2Carticle%2Cpage';
      return '<a href="' + href + '"' + (ist(o[0]) ? ' class="is-active" aria-current="true"' : '') + '>' + o[1] + '</a>';
    }).join('');
    ziel.parentNode.insertBefore(zeile, ziel);
  }
  function mobilUntermenue() {
    var drawer = document.querySelector('#t4s-menu-drawer'); if (!drawer) return;
    drawer.querySelectorAll('li.t4s-item-level-0.t4s-menu-item-has-children').forEach(function (li) {
      if (li.dataset.aiToggle) return;
      var a = li.querySelector(':scope > a'), sub = li.querySelector(':scope > ul'), ico = a && a.querySelector('.t4s-mb-nav__icon');
      if (!a || !sub) return; li.dataset.aiToggle = '1';
      var href = a.getAttribute('href') || '', label = (a.querySelector('.t4s-nav_link_txt') || a).textContent.trim();
      var schonDa = [].some.call(sub.querySelectorAll('a'), function (x) { return (x.getAttribute('href') || '').replace(/\/$/, '') === href.replace(/\/$/, ''); });
      if (href && href !== '#' && !schonDa && !sub.querySelector('.ai-mbmenu__alle')) {
        var erste = document.createElement('li'); erste.className = 't4s-menu-item t4s-item-level-1 ai-mbmenu__alle';
        var lab = label === label.toUpperCase() ? label.charAt(0) + label.slice(1).toLowerCase() : label; var txt = /über/i.test(label) ? T('ueber_peeck', 'Über Peeck') : T('alle_prefix', 'Alle ') + lab; erste.innerHTML = '<a href="' + href + '">' + txt + '</a>'; sub.insertBefore(erste, sub.firstChild);
      }
      a.addEventListener('click', function (e) {
        if (e.target.closest('.t4s-mb-nav__icon')) return;
        e.preventDefault(); e.stopPropagation();
        if (ico) ico.click(); else sub.classList.toggle('ai-offen');
      }, true);
    });
    var help = drawer.querySelector('.t4s-menu-item-infos .t4s-menu_infos_text');
    if (help && !help.querySelector('.ai-mbmenu__links')) {
      help.insertAdjacentHTML('beforeend', '<p class="ai-mbmenu__links"><a href="' + U('/pages/standorte') + '">' + T('berater_teams', 'Ihre Berater: Teams in Mannheim und Worms') + '</a></p><p class="ai-mbmenu__links"><a href="' + U('/pages/faq') + '">' + T('faq', 'Fragen und Antworten') + '</a> · <a href="' + U('/pages/preisgarantie') + '">' + T('preisgarantie', 'Preisgarantie') + '</a> · <a href="' + U('/pages/service') + '">' + T('service', 'Service') + '</a> · <a href="' + U('/pages/jobs') + '">' + T('jobs', 'Jobs') + '</a></p>');
    }
  }
  /* Runde 11: Kacheln ohne Preis sagen es (statt Leerstelle); Sortierung nach Preis stellt sie ans Ende (CSS order). */
  function preisHinweis() {
    document.querySelectorAll('.t4s-product').forEach(function (tile) {
      if (tile.dataset.aiPreis) return;
      var preis = tile.querySelector('.t4s-product-price'), titel = tile.querySelector('.t4s-product-title');
      var hatZahl = preis && /\d/.test(preis.textContent);
      if (hatZahl) { tile.dataset.aiPreis = '1'; return; }
      if (!preis && !titel) return;
      tile.dataset.aiPreis = '0'; tile.classList.add('mp-ohne-preis');
      /* Felix, 16.09.2026: In der Uebersicht steht gar kein Preishinweis mehr, auch nicht
         bei Elektrogeraeten. Die Kachel zeigt Bild und Namen, den Preis klaert die
         Produktseite oder die Beratung.
         ⚠ Die Klasse mp-ohne-preis bleibt gesetzt, an ihr haengt die Sortierung
         (Kacheln ohne Preis wandern ans Ende). */
      return;
    });
  }
  function mobilMenue() {
    var d = document.getElementById('t4s-menu-drawer'); if (!d) return;
    d.querySelectorAll('#menu-mb__ul > li').forEach(function (li) {
      var a = li.querySelector(':scope > a'); if (!a || a.dataset.aiWort) return;
      var t = null, w0 = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), n;
      while ((n = w0.nextNode())) { if (n.textContent.trim()) { t = n; break; } }
      if (!t) return;
      var w = t.textContent.trim();
      if (/AKTIONEN/i.test(w)) { t.textContent = T('angebote', 'Angebote'); a.setAttribute('href', einst('angebote_url', '/pages/angebote')); a.removeAttribute('target'); }
      else if (/^SALE$/i.test(w)) { t.textContent = 'Sale'; li.classList.add('ai-mb-sale'); }
      else if (w.length > 1 && w === w.toUpperCase()) t.textContent = w.charAt(0) + w.slice(1).toLowerCase();
      a.dataset.aiWort = '1';
    });
    var kopf = d.querySelector('.mp-mbmenu__head');
    if (kopf && !d.querySelector('.ai-mbmenu__cta')) {
      var cta = document.createElement('a');
      cta.className = 'ai-mbmenu__cta appointmentButton';
      cta.href = location.pathname + '?appointment';
      cta.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>' + einst('mobil_cta', T('mobil_cta', 'Planungstermin vereinbaren'));
      kopf.insertAdjacentElement('afterend', cta);
      /* 13.10.2026 Website-CTA: KI-Küchenplaner als zweiter Knopf unter dem Termin */
      var ki = document.createElement('a');
      ki.className = 'ai-mbmenu__cta ai-mbmenu__cta--zweit';
      ki.setAttribute('data-mp-funnel', 'kuechenwunsch'); ki.href = '/pages/traumkueche-planen';
      ki.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z"/><path d="M19 3v4M17 5h4"/></svg>' + T('ki_start', 'KI-Küchenplaner starten');
      cta.insertAdjacentElement('afterend', ki);
    }
    // Desktop: "Angebote" zeigt in der Testversion auf die nachgebaute Prospektseite statt auf die externe Micropage
    document.querySelectorAll('#t4s-nav-ul a[href*="aktionen.moebel-peeck.de"], .t4s-nav-ul a[href*="aktionen.moebel-peeck.de"], #t4s-nav-ul a[href$="/pages/angebote"], #menu-mb__ul a[href$="/pages/angebote"]').forEach(function (a) { a.setAttribute('href', einst('angebote_url', '/pages/angebote')); a.removeAttribute('target'); });
  }

  /* 2e) Theme-Fehler abfangen: der Versandrechner im Warenkorb erzeugt CountryProvinceSelector ohne
     passende Felder (global.min.js, geladen nach uns) -> Setter-Falle, die den Konstruktor absichert */
  function selectorSchutz() {
    if (!window.Shopify || window.Shopify.aiSelectorSchutz) return;
    window.Shopify.aiSelectorSchutz = true;
    var wert = window.Shopify.CountryProvinceSelector;
    function sichern(Orig) {
      if (!Orig || Orig.aiGeschuetzt) return Orig;
      var Sicher = function (c, p, o) {
        if (!document.getElementById(c) || !document.getElementById(p)) return {};
        try { return new Orig(c, p, o); } catch (e) { return {}; }
      };
      Sicher.prototype = Orig.prototype; Sicher.aiGeschuetzt = true; return Sicher;
    }
    try {
      Object.defineProperty(window.Shopify, 'CountryProvinceSelector', {
        configurable: true, enumerable: true,
        get: function () { return wert; },
        set: function (v) { wert = sichern(v); }
      });
      if (wert) wert = sichern(wert);
    } catch (e) { if (wert) window.Shopify.CountryProvinceSelector = sichern(wert); }
  }
  /* 2f) Buehnen-Videos erst nach dem Laden starten: das Theme-JS klont das Video sofort mit autoplay,
     die Datei (bis 3 MB) blockiert auf Mobilnetz den Rest der Seite. Wir ziehen die Quellen heraus,
     brechen den Download ab und setzen sie nach dem load-Ereignis (plus kurzer Ruhe) wieder ein. */
  var videosBereit = false, wartend = [];
  function videoAnhalten(v) {
    if (v.dataset.aiVideo || videosBereit) return;
    v.dataset.aiVideo = '1';
    var quellen = Array.prototype.slice.call(v.querySelectorAll('source'));
    var srcs = quellen.map(function (q) { return { src: q.getAttribute('src'), type: q.getAttribute('type') }; });
    if (v.getAttribute('src')) srcs.unshift({ src: v.getAttribute('src'), type: v.getAttribute('type') });
    if (!srcs.length) return;
    v.dataset.aiSrcs = JSON.stringify(srcs);
    quellen.forEach(function (q) { q.parentNode.removeChild(q); });
    v.removeAttribute('src'); v.setAttribute('preload', 'none');
    try { v.pause(); v.load(); } catch (e) {}
    wartend.push(v);
  }
  function ruhigeBewegung() {
    try { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function videosStarten() {
    videosBereit = true;
    var sparen = navigator.connection && navigator.connection.saveData;
    /* Datensparmodus oder "Bewegung reduzieren": kein Video laden. Die Buehne traegt
       dann ihr Standbild, deshalb bleibt an der Stelle kein leeres Feld. */
    if (sparen || ruhigeBewegung()) {
      wartend.forEach(function (v) { var b = v.closest && v.closest('.ai-buehne'); if (b) b.classList.add('is-ruhig'); });
      wartend = [];
      return;
    }
    var rest = [];
    wartend.forEach(function (v) {
      /* Die gerade nicht sichtbare Fassung (Mobilvideo am Rechner und umgekehrt) gar
         nicht erst holen: sonst laedt jeder Besuch beide Dateien. */
      var sichtbar = true;
      try { sichtbar = window.getComputedStyle(v).display !== 'none'; } catch (e) {}
      if (!sichtbar) { rest.push(v); return; }
      var srcs = []; try { srcs = JSON.parse(v.dataset.aiSrcs || '[]'); } catch (e) {}
      if (!srcs.length) return;
      srcs.forEach(function (q) { var s = document.createElement('source'); s.setAttribute('src', q.src); if (q.type) s.setAttribute('type', q.type); v.appendChild(s); });
      v.setAttribute('preload', 'auto'); v.muted = true;
      try { v.load(); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {}
    });
    wartend = rest;
  }
  /* Breitenwechsel (Drehen des Geraets, Fenster ziehen): jetzt sichtbare Fassung nachladen */
  var videoTakt = null;
  window.addEventListener('resize', function () {
    if (!wartend.length) return;
    clearTimeout(videoTakt); videoTakt = setTimeout(videosStarten, 400);
  });
  function videosVerzoegern() {
    document.querySelectorAll('.t4s-bg-video video, .ai-buehne video, .mp-header-video video, .t4s-hero-inner video').forEach(videoAnhalten);
  }
  window.addEventListener('load', function () {
    var los = function () { setTimeout(videosStarten, 900); };
    if ('requestIdleCallback' in window) requestIdleCallback(los, { timeout: 2500 }); else los();
  });
  /* Falls load sehr lange dauert (langsames Netz): spaetestens nach 6 s starten */
  setTimeout(function () { if (!videosBereit) videosStarten(); }, 6000);

  /* 2g) Drittskripte im Fuss (Brevo-Formular, reCAPTCHA) erst laden, wenn der Fuss in die Naehe kommt */
  function fussSkripte() {
    /* Datenschutz 2026-10-01: reCAPTCHA (Google) erst laden, wenn jemand das Newsletterformular
       anfasst (Klick, Tippen, Fokus). Brevo-Formularskript weiter, sobald der Fuss in die Naehe kommt. */
    var alle = [].slice.call(document.querySelectorAll('script[type="text/ai-lazy"][data-ai-src]'));
    var captcha = alle.filter(function (p) { return /recaptcha/.test(p.dataset.aiSrc); });
    var platz = alle.filter(function (p) { return !/recaptcha/.test(p.dataset.aiSrc); });
    if (captcha.length) {
      var captchaLaden = function (e) {
        if (!e.target || !e.target.closest || !e.target.closest('.sib-form, [class*="sib-form"], #sib-form')) return;
        captcha.forEach(skriptLaden);
        ['focusin', 'pointerdown', 'touchstart'].forEach(function (t) { document.removeEventListener(t, captchaLaden, true); });
      };
      ['focusin', 'pointerdown', 'touchstart'].forEach(function (t) { document.addEventListener(t, captchaLaden, { capture: true, passive: true }); });
    }
    if (!platz.length) return;
    if (!('IntersectionObserver' in window)) { platz.forEach(function (p) { skriptLaden(p); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { platz.forEach(skriptLaden); io.disconnect(); } }); }, { rootMargin: '600px 0px' });
    var ziel = document.querySelector('.sib-form, [class*="sib-form"], footer, .t4s-footer') || document.body.lastElementChild;
    io.observe(ziel);
    document.addEventListener('focusin', function (e) { if (e.target && e.target.closest && e.target.closest('.sib-form, form')) { platz.forEach(skriptLaden); } }, { once: true });
  }
  function skriptLaden(p) {
    if (p.dataset.aiGeladen) return; p.dataset.aiGeladen = '1';
    var s = document.createElement('script'); s.src = p.dataset.aiSrc; s.async = true; if (p.dataset.aiDefer) s.defer = true; document.body.appendChild(s);
  }

  /* 2h) Markenraster: Filter-Chips */
  function markenFilter() {
    var f = document.querySelector('.ai-marken__filter'); if (!f || f.dataset.aiFilter) return; f.dataset.aiFilter = '1';
    f.addEventListener('click', function (e) {
      var chip = e.target.closest('.ai-chip'); if (!chip) return;
      f.querySelectorAll('.ai-chip').forEach(function (c) { c.classList.toggle('is-aktiv', c === chip); });
      var g = chip.dataset.aiGruppe;
      document.querySelectorAll('.ai-marke').forEach(function (m) { m.classList.toggle('is-weg', g !== 'alle' && m.dataset.aiGruppe !== g); });
    });
  }

  /* 1) Reveal fuer alles, was es verdient --------------------------------- */
  function markieren() {
    if (reduziert) return;
    var sel = [
      'main .shopify-section .t4s-section-title', 'main .shopify-section .t4s-section-des',
      'main .t4s-collection-item', 'main .t4s-article-item',
      'main .t4s-feature-columns__item, main .t4s-col-item.t4s-feature-columns__col, main .t4s-feature-columns .t4s-col-item',
      '.ai-kapitel', '.ai-split__text', '.ai-parallax', '.ai-leistung', '.ai-finale',
      '.mp-mh-card, .mp-mh-head, .mp-st-card, .mp-st-head'
    ].join(',');
    var alle = document.querySelectorAll(sel);
    var proEltern = new Map();
    alle.forEach(function (el) {
      if (el.hasAttribute('data-ai-reveal')) return;
      // nichts animieren, was beim Laden schon im Bild ist
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85 && r.bottom > 0) return;
      var p = el.parentElement;
      var i = proEltern.get(p) || 0; proEltern.set(p, i + 1);
      el.setAttribute('data-ai-reveal', '');
      el.style.setProperty('--ai-i', Math.min(i, 6));
    });
  }
  var beobachter = null;
  function beobachten() {
    if (reduziert || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-ai-reveal]').forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    beobachter = beobachter || new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); beobachter.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('[data-ai-reveal]:not(.is-in)').forEach(function (e) { beobachter.observe(e); });
  }

  /* 3) Parallax ------------------------------------------------------------ */
  function parallax() {
    if (reduziert) return;
    var boxen = document.querySelectorAll('.ai-parallax');
    if (!boxen.length) return;
    var ticking = false;
    function lauf() {
      boxen.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var mitte = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight; /* -1 .. 1 */
        var img = b.querySelector('img');
        if (img) img.style.transform = 'translateY(' + (mitte * -9).toFixed(2) + '%)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(lauf); } }, { passive: true });
    lauf();
  }

  /* 3f) Klebende Kopfleiste: sobald sie oben aufsitzt, traegt sie einen feinen
     Schatten, damit sie sich vom durchlaufenden Inhalt abhebt. */
  function kopfKleben() {
    var kopf = document.querySelector('.t4s-section-header');
    if (!kopf || kopf.dataset.aiKleben) return;
    kopf.dataset.aiKleben = '1';
    var laeuft = false;
    var pruefen = function () {
      laeuft = false;
      var oben = kopf.getBoundingClientRect().top <= 1 && window.scrollY > 8;
      kopf.classList.toggle('is-ai-klebt', oben);
    };
    window.addEventListener('scroll', function () {
      if (laeuft) return; laeuft = true;
      (window.requestAnimationFrame || setTimeout)(pruefen);
    }, { passive: true });
    pruefen();
  }

  /* 4) Laufband verdoppeln, damit die Schleife nahtlos ist ------------------ */
  function laufband() {
    var ruhig = ruhigeBewegung();
    document.querySelectorAll('.ai-marquee__track').forEach(function (t) {
      if (t.dataset.aiDoppelt) return;
      t.dataset.aiDoppelt = '1';
      /* Bei "Bewegung reduzieren" waere ein stehendes Band nur ein angeschnittener Satz.
         Stattdessen die Punkte einmal zeigen und umbrechen lassen. */
      if (ruhig) { var m = t.closest('.ai-marquee'); if (m) m.classList.add('ai-marquee--ruhig'); return; }
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  /* 5) Menue: Shopify liefert die Labels in Versalien; hier werden Woerter daraus */
  function menueWoerter() {
    // Untermenues: jedes Wort gross, Rest klein (AKTUELLE AKTIONEN -> Aktuelle Aktionen)
    document.querySelectorAll('#t4s-nav-ul .t4s-sub-menu a, .t4s-nav-ul .t4s-sub-menu a, #t4s-nav-ul [class*="dropdown"] a, #menu-mb__ul .t4s-sub-menu a').forEach(function (a) {
      if (a.dataset.aiWort) return;
      var t = null, w0 = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), n;
      while ((n = w0.nextNode())) { if (n.textContent.trim()) { t = n; break; } }
      if (!t) return;
      var w = t.textContent.trim();
      if (w.length > 3 && w === w.toUpperCase() && /[A-ZÄÖÜ]{3}/.test(w)) { t.textContent = w.toLowerCase().replace(/(^|[\s\-\/])(\S)/g, function (m0, p1, p2) { return p1 + p2.toUpperCase(); }); a.dataset.aiWort = '1'; }
    });
    document.querySelectorAll('#t4s-nav-ul > li > a, .t4s-nav-ul > li > a, .t4s-mb-menu > li > a, [data-menu-nav] > li > a').forEach(function (a) {
      if (a.dataset.aiWort) return;
      // erster Textknoten mit Inhalt, egal wie tief (Theme: <a><b>ANGEBOTE</b></a>)
      var t = null, w0 = document.createTreeWalker(a, NodeFilter.SHOW_TEXT), n;
      while ((n = w0.nextNode())) { if (n.textContent.trim()) { t = n; break; } }
      if (!t) return;
      var w = t.textContent.trim();
      if (w.length > 1 && w === w.toUpperCase()) { t.textContent = w.charAt(0) + w.slice(1).toLowerCase(); a.dataset.aiWort = '1'; }
    });
  }
  /* 6) Seitenkoepfe: Hintergrundbild aus data-bgset (breit) setzen, Theme-Lazyloader haengt */
  function kopfbild() {
    document.querySelectorAll('.t4s-page-section-heading[data-bgset]:not(.ai-kopfbild)').forEach(function (h) {
      var src = (h.getAttribute('data-bgset') || '').split(',')[0].trim().split(' ')[0];
      if (!src) return;
      src = src.replace(/([?&])width=\d+/, '$1width=1800');
      if (src.indexOf('width=') < 0) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
      h.style.setProperty('--ai-kopfbild', 'url("' + src + '")');
      h.classList.add('ai-kopfbild');
    });
  }
  /* 7) Standortkarten: vier Bilder je Haus ueberblenden (Sektion mp-ai-standorte) */
  function standortSlides() {
    if (reduziert) return;
    document.querySelectorAll('.mp-st-slides').forEach(function (g) {
      if (g.dataset.aiSlides) return; g.dataset.aiSlides = '1';
      var imgs = g.querySelectorAll('img'); if (imgs.length < 2) return;
      var laden = function () { imgs.forEach(function (im) { if (im.dataset.src && !im.src) im.src = im.dataset.src; }); };
      var starten = function () { laden(); var i = 0; setInterval(function () { imgs[i].classList.remove('is-on'); i = (i + 1) % imgs.length; imgs[i].classList.add('is-on'); }, 4500); };
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); starten(); } }, { rootMargin: '300px 0px' }); io.observe(g); } else starten();
    });
  }
  /* Kopfbild wechseln: der Seitenkopf ist eine Buehne mit --ai-kopfbild als Hintergrund.
     Statt eine zweite Sektion darueberzusetzen (dabei standen zwei Koepfe uebereinander),
     blenden wir das Bild im vorhandenen Kopf weich durch eine Liste. Die Liste kommt als
     JSON aus einer custom-liquid-Sektion, damit Bilder ohne Codeaenderung tauschbar sind. */
  function kopfSlideshow() {
    var quelle = document.getElementById('mp-kopf-folien');
    var kopf = document.querySelector('.t4s-page-section-heading');
    if (!quelle || !kopf || kopf.dataset.aiFolien) return;
    var bilder; try { bilder = JSON.parse(quelle.textContent); } catch (e) { return; }
    if (!bilder || bilder.length < 2) return;
    kopf.dataset.aiFolien = '1';

    /* Eine zweite Ebene liegt ueber dem Kopfbild und wird ein- und ausgeblendet.
       ⚠ z-index 0: der Verlauf (::before, z-index 1) und der Titel (z-index 2) muessen
       darueber bleiben, sonst verschwindet die Schrift hinter dem Bild. */
    var ebene = document.createElement('div');
    ebene.className = 'ai-kopf-folie';
    kopf.insertBefore(ebene, kopf.firstChild);

    var i = 0, ruhig = false;
    try { ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    bilder.forEach(function (u) { var v = new Image(); v.src = u; });   // vorladen
    if (ruhig) return;

    setInterval(function () {
      i = (i + 1) % bilder.length;
      ebene.style.backgroundImage = 'url("' + bilder[i] + '")';
      ebene.classList.add('ist-da');
      setTimeout(function () {
        kopf.style.setProperty('--ai-kopfbild', 'url("' + bilder[i] + '")');
        ebene.classList.remove('ist-da');
      }, 900);
    }, 6000);
  }

  /* 25.09.2026 (Register r629): Kampagnen-Parameter an Termin-Links weiterreichen. Alle
     "Planungstermin vereinbaren"-Knoepfe mit eigenem href zeigen fest auf "...?appointment"
     (Kollektionsbanner, Seiten-CTAs, Beratungskarte, Mobilmenue). Kam ein Besucher mit
     utm_source/utm_campaign auf die Seite, ging das beim Klick verloren, weil der Link auf
     eine neue URL ohne diese Parameter springt (gclid ueberlebt, weil Google Ads das separat
     per Cookie/Auto-Tagging traegt). Der Kopf-Knopf #menu-cta ist ein <button> ohne href
     (das Leadanizer-Widget oeffnet direkt per Klassen-Klick, keine Navigation, daher dort
     kein Verlust) - betroffen sind nur <a href="...?appointment">. */
  function terminParameter() {
    if (!location.search || location.search.length < 2) return;
    var eigene = new URLSearchParams(location.search);
    eigene.delete('appointment');
    var hatWerte = false; eigene.forEach(function () { hatWerte = true; });
    if (!hatWerte) return;
    document.querySelectorAll('a[href*="appointment"]').forEach(function (a) {
      if (a.dataset.aiTerminP) return;
      var href = a.getAttribute('href') || '';
      if (!/[?&]appointment(&|$)/.test(href)) return;
      var ziel;
      try { ziel = new URL(href, location.origin); } catch (e) { return; }
      eigene.forEach(function (wert, key) { if (!ziel.searchParams.has(key)) ziel.searchParams.set(key, wert); });
      a.setAttribute('href', ziel.pathname + '?' + ziel.searchParams.toString());
      a.dataset.aiTerminP = '1';
    });
  }

  /* Nur wenn nach Preis sortiert wird, sollen Kacheln ohne Preis ans Ende. Sonst
     zerreisst das Umsortieren das Raster (siehe Abschnitt 39 im CSS). */
  function sortKlasse() {
    var nachPreis = /sort_by=[^&]*price/i.test(location.search);
    document.querySelectorAll('.t4s-products').forEach(function (r) {
      r.classList.toggle('mp-sort-preis', nachPreis);
    });
  }

  function start() { spracheKlick(); spracheLinks(); sortKlasse(); kopfSlideshow(); kopfKleben(); ankerIds(); sprachwahl(); markenFilter(); videosVerzoegern(); heroWoerter(); heroKnoepfe(); kopfTelefon(); menueWoerter(); mobilMenue(); kopfbild(); standortSlides(); laufband(); beratungskarte(); fussSkripte(); markieren(); beobachten(); parallax(); selectorSchutz(); terminParameter(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', function () { selectorSchutz(); setTimeout(function () { spracheLinks(); heroWoerter(); heroKnoepfe(); beratungskarte(); sprachwahl(); mobilUntermenue(); drawerX(); menueAktuell(); kartenFreigabe(); sortWort(); sortWert(); zugaenglich(); suchTypen(); chipIcons(); preisHinweis(); suchAntworten(); markieren(); beobachten(); terminParameter(); }, 300); });
  /* Theme laedt Teile nach (AJAX, Lazy): neue Elemente ebenfalls einfahren lassen */
  try {
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (n.tagName === 'VIDEO') videoAnhalten(n); else if (n.querySelectorAll) n.querySelectorAll('video').forEach(videoAnhalten); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { spracheLinks(); sortKlasse(); videosVerzoegern(); heroWoerter(); heroKnoepfe(); menueWoerter(); mobilMenue(); kopfbild(); beratungskarte(); sprachwahl(); mobilUntermenue(); drawerX(); menueAktuell(); kartenFreigabe(); sortWort(); sortWert(); zugaenglich(); suchTypen(); chipIcons(); preisHinweis(); suchAntworten(); markieren(); beobachten(); laufband(); terminParameter(); }, 200); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
